export default "__VITE_ASSET__953a70fd__"